// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { UnlinkFromParentCardArgs_abstract } from './../../abstract/SagaBase/Defines/UnlinkFromParentCardArgs_abstract';
export class UnlinkFromParentCardArgs extends UnlinkFromParentCardArgs_abstract {}
